import { create } from 'zustand';
import { AssessmentResults, OrganizationData } from '../types';

interface AssessmentState {
  currentResponses: Record<string, number>;
  results: AssessmentResults | null;
  organizationData: OrganizationData | null;
  isComplete: boolean;
  setResponse: (questionId: string, value: number) => void;
  setResults: (results: AssessmentResults) => void;
  setOrganizationData: (data: OrganizationData) => void;
  clearAssessment: () => void;
}

export const useAssessmentStore = create<AssessmentState>((set) => ({
  currentResponses: {},
  results: null,
  organizationData: null,
  isComplete: false,
  setResponse: (questionId, value) => 
    set((state) => ({
      currentResponses: { ...state.currentResponses, [questionId]: value }
    })),
  setResults: (results) => 
    set({ results, isComplete: true }),
  setOrganizationData: (data) => 
    set({ organizationData: data }),
  clearAssessment: () => 
    set({ 
      currentResponses: {}, 
      results: null, 
      organizationData: null, 
      isComplete: false 
    })
}));